export const DEBOUNCE_DELAY = 300;
export const defaultPager = { page: 1, pageSize: 10 };

export const inOrderColumns = [
  {
    columnName: "desc",
    displayNameKey: "Descending"
  },
  {
    columnName: "asc",
    displayNameKey: "Ascending"
  }
];

export const pfSortableColumns = [
  {
    columnName: "PartnerName",
    displayNameKey: "OfferEdit.Client.Name"
  },
  {
    columnName: "UniqueId",
    displayNameKey: "OfferEdit.Client.PersonalIdentifier"
  },
  {
    columnName: "CitizenshipId",
    displayNameKey: "OfferEdit.Client.Citizenship"
  },
  {
    columnName: "NationalityId",
    displayNameKey: "OfferEdit.Client.Nationality"
  },
  {
    columnName: "IdSeriesAndNumber",
    displayNameKey: "OfferEdit.Client.PassportSeriesAndNumber"
  },
  {
    columnName: "CountryId",
    displayNameKey: "OfferEdit.Client.Country"
  },
  {
    columnName: "CountyId",
    displayNameKey: "OfferEdit.Client.County"
  },
  {
    columnName: "CityId",
    displayNameKey: "OfferEdit.Client.City"
  },
  {
    columnName: "BirthDate",
    displayNameKey: "OfferEdit.Client.BirthDate"
  }
];

export const pjSortableColumns = [
    {
      columnName: "UniqueId",
      displayNameKey: "OfferEdit.Client.PJ.PersonalIdentifier"
    },
    {
      columnName: "PartnerName",
      displayNameKey: "OfferEdit.Client.PJ.CompanyName"
    },
    {
      columnName: "LegalFormName",
      displayNameKey: "OfferEdit.Client.PJ.LegalForm"
    }
  ];
